import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';
import styled, { css } from 'styled-components';

const ContentWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  ${({ theme }) => theme.breakpoints.maxMobile} {
    display: grid;
    grid-gap: 1.6rem;
    grid-template-columns: repeat(auto-fit, minmax(9.2rem, auto));
  }
`;

const ImageWrapper = styled.div`
  height: 4.8rem;
  width: 13.4rem;
  display: flex;
  justify-content: center;
  align-items: center;

  ${({ theme }) => theme.breakpoints.maxTablet} {
    height: 3.7rem;
    width: 10.3rem;
  }

  ${({ theme }) => theme.breakpoints.maxMobile} {
    height: 3.2rem;
    width: 9.3rem;

    ${({ showAll }) =>
      !showAll &&
      css`
        &:nth-child(n + 4) {
          display: none;
        }
      `}

    svg {
      transform: scale(0.7);
    }
  }
`;

const Img = styled.img`
  width: 10.3rem;

  ${({ theme }) => theme.breakpoints.maxTablet} {
    width: 10.3rem;
  }

  ${({ theme }) => theme.breakpoints.maxMobile} {
    width: 6rem;
  }
`;

const ClientLogos = ({ showAll }) => {
  const { logos } = useStaticQuery(
    graphql`
      query {
        logos: file(name: { eq: "clientLogos" }) {
          childMarkdownRemark {
            frontmatter {
              clientLogos {
                imageContainer {
                  altText
                  image {
                    publicURL
                  }
                }
              }
            }
          }
        }
      }
    `
  );

  const { clientLogos } = logos.childMarkdownRemark.frontmatter;

  return (
    <ContentWrapper>
      {clientLogos.map(({ imageContainer: { image, altText } }, index) => (
        <div
          data-sal="slide-up"
          data-sal-easing="ease"
          data-sal-delay={(index + 1) * 100}
          key={image.publicURL}
        >
          <ImageWrapper key={altText} showAll={showAll}>
            <Img src={image.publicURL} alt={altText} width="134px" height="48px" />
          </ImageWrapper>
        </div>
      ))}
    </ContentWrapper>
  );
};

export default ClientLogos;
